import React, { useState } from 'react';
import { SimplePDFPreview } from './SimplePDFPreview';
import { EnhancedPDFPreview } from './EnhancedPDFPreview';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function PDFTestPage() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [useObject, setUseObject] = useState(true);
  const [useEnhanced, setUseEnhanced] = useState(true);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      console.log('PDFTestPage: File selected:', file.name, file.type, file.size);
      setSelectedFile(file);
    }
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file?.type === 'application/pdf') {
      console.log('PDFTestPage: File dropped:', file.name, file.type, file.size);
      setSelectedFile(file);
    } else {
      alert('Please upload a PDF file');
    }
  };

  return (
    <div className="p-4 space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>PDF Preview Test</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <input
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
              className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              aria-label="Select PDF file"
            />
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setUseEnhanced(!useEnhanced)}
            >
              {useEnhanced ? 'Use Simple' : 'Use Enhanced'}
            </Button>
            {!useEnhanced && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => setUseObject(!useObject)}
              >
                {useObject ? 'Use Iframe' : 'Use Object'}
              </Button>
            )}
            <span className="text-sm text-slate-600">
              Current: {useEnhanced ? 'Enhanced (PDF.js)' : useObject ? 'Object Tag' : 'Iframe'}
            </span>
          </div>

          <div
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            className="border-2 border-dashed border-slate-300 rounded-lg p-8 text-center"
          >
            <p className="text-slate-600">Or drag and drop a PDF file here</p>
          </div>

          {selectedFile && (
            <div className="border rounded-lg p-4">
              <h3 className="font-medium mb-2">File: {selectedFile.name}</h3>
              <div className="h-96">
                {useEnhanced ? (
                  <EnhancedPDFPreview 
                    file={selectedFile} 
                    className="h-full"
                  />
                ) : (
                  <SimplePDFPreview 
                    file={selectedFile} 
                    className="h-full" 
                    useObject={useObject}
                  />
                )}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
